export const contentCategories = {
  directGuestVariant: 'Direct guest variant',
  otaVariant: 'OTA variant'
}
